import { Shield } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../contexts/auth-context";
import { Button } from "./ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function LoginPage() {
	const { login, loginMode } = useAuth();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);
		setLoading(true);
		try {
			await login(username, password);
		} catch (err) {
			setError(err instanceof Error ? err.message : "Login failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-background flex items-center justify-center p-4">
			<Card className="w-full max-w-sm">
				<CardHeader className="text-center">
					<div className="flex justify-center mb-2">
						<div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
							<Shield className="h-7 w-7 text-primary" />
						</div>
					</div>
					<CardTitle className="text-2xl">ccflare</CardTitle>
					<CardDescription>Sign in to access the dashboard</CardDescription>
				</CardHeader>
				<CardContent>
					{loginMode === "azure" ? (
						<Button
							type="button"
							className="w-full"
							onClick={() => {
								window.location.href = "/api/auth/azure/login";
							}}
						>
							Sign in with Microsoft
						</Button>
					) : (
						<form onSubmit={handleSubmit} className="space-y-4">
							<div className="space-y-2">
								<Label htmlFor="username">Username</Label>
								<Input
									id="username"
									type="text"
									autoComplete="username"
									value={username}
									onChange={(e) => setUsername(e.target.value)}
									disabled={loading}
									required
								/>
							</div>
							<div className="space-y-2">
								<Label htmlFor="password">Password</Label>
								<Input
									id="password"
									type="password"
									autoComplete="current-password"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									disabled={loading}
									required
								/>
							</div>
							{error && <p className="text-sm text-destructive">{error}</p>}
							<Button type="submit" className="w-full" disabled={loading}>
								{loading ? "Signing in..." : "Sign in"}
							</Button>
						</form>
					)}
				</CardContent>
			</Card>
		</div>
	);
}
